import React from "react";
import { RatingInfoContent } from "./RatingInfoContent";

export const SkillsRatingInfo = () => <RatingInfoContent dimension="skills" />;

export default SkillsRatingInfo;
